import { css, StyleSheet } from 'aphrodite/no-important';
/**
 * getClasses takes a function as argument that returns style definitions for Aphrodite
 * The returned function can be used with arguments such as theme to create all class names for the style definition
 * to be used within a component
 */
export var generateClasses = function (generateStyles, otherStyles) {
    return function (theme) {
        var styles = StyleSheet.create(generateStyles(theme));
        var classes = {};
        for (var property in styles) {
            classes[property] = css(styles[property], otherStyles);
        }
        return classes;
    };
};
